import { featureType } from './interfaces/IFeatureFlagProps';
import ConfigurationManager from '../../../utils/configurationManager';

export default async function isFeatureFlagEnabled(
    type: featureType,
): Promise<boolean> {
    const { FEATURE_FLAGS } =
        await ConfigurationManager.getInstance().getConfigFile();
    return FEATURE_FLAGS?.some(
        l => l.name === type.toString() && l.active === 'true',
    );
}
